/* Delfino — section-product-body-zones.js
   „Unde îl folosești”: punctele de pe siluetă și rândurile listei deschid aceeași explicație
   (una singură deschisă). Cârlige: [data-dl-zones] rădăcina, [data-dl-zone-dot], [data-dl-zone-item],
   [data-dl-zone-btn]. Idempotent (dataset.bound) și reinițializat la shopify:section:load.
   Fără JS, toate explicațiile rămân vizibile — CSS-ul le ascunde doar sub `.is-enhanced`. */
(function () {
  'use strict';
  function bind(root) {
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';
    var dots = root.querySelectorAll('[data-dl-zone-dot]');
    var items = root.querySelectorAll('[data-dl-zone-item]');
    if (!items.length) return;
    function activate(index, fromDot) {
      for (var i = 0; i < items.length; i++) {
        var on = i === index;
        items[i].classList.toggle('is-active', on);
        var btn = items[i].querySelector('[data-dl-zone-btn]');
        if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      }
      for (var d = 0; d < dots.length; d++) {
        var active = Number(dots[d].getAttribute('data-dl-zone-dot')) === index;
        dots[d].classList.toggle('is-active', active);
        dots[d].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
      // Pe telefon lista e sub siluetă: după un punct atins, adu rândul deschis în ecran.
      if (fromDot && items[index] && items[index].scrollIntoView) {
        var r = items[index].getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (r.top < 0 || r.bottom > vh) {
          var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          items[index].scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
        }
      }
    }
    root.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-dl-zone-dot],[data-dl-zone-btn]') : null;
      if (!t || !root.contains(t)) return;
      var isDot = t.hasAttribute('data-dl-zone-dot');
      activate(Number(t.getAttribute(isDot ? 'data-dl-zone-dot' : 'data-dl-zone-btn')), isDot);
    });
    root.classList.add('is-enhanced');
    activate(0, false);
  }
  function init(scope) {
    var list = (scope || document).querySelectorAll('[data-dl-zones]');
    for (var i = 0; i < list.length; i++) bind(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest ? e.target.closest('[data-dl-zone-item]') : null;
    if (!item) return;
    var btn = item.querySelector('[data-dl-zone-btn]');
    if (btn) btn.click();
  });
})();
